import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../components/Modal/CustomModal";
import CustomDescriptionLabel from "../../components/CustomDescriptionLabel";
import CustomListContainer from "../../components/CustomListContainer";
import CustomListItem from "../../components/CustomListItem";

const CreationErrorsModal = (props) => {
    const {show, onHide} = props;
    const { t } = useTranslation();
    const { uploadFormFile } = useSelector((state) => state.FilesSlice);
    const { analizeCards } = useSelector((state) => state.CardsSlice);

    const errorsArray = props.cards
        ? analizeCards
            ? analizeCards?.data?.filter((item) => item.comment !== null)
            : []
        : uploadFormFile
          ? uploadFormFile?.data?.filter((item) => item.comment !== null)
          : [];
    return (
        <CustomModal
            title={"creation_errors"}
            show={show}
            size="lg"
            cancelButton={false}
            confirmButton={false}
            onHide={onHide}
            classNameBody="pt-2"
        >
            <div className={"row"}>
                <div className={"col-12"}>
                    <CustomDescriptionLabel trans={props.cards ? (
                        <>
                            {t('some_errors_appeared_when_creating')}
                            {'. '}
                            {t('read_in_the_box_correct_them_and_try_the_creation_again')}
                        </>
                        ) : (
                            <>
                                {t('some_errors_appeared_when_creating')}
                                {'. '}
                                {t('read_in_the_box_correct_them_and_upload_the_file_again')}
                            </>
                        )}
                    />
                </div>
                <div className={"col-12 pl-5"}>
                    <CustomListContainer styleType={"disc"}>
                        {errorsArray?.map((item, index) => (
                            <CustomListItem
                                key={item?.id}
                                text={`${item?.comment}`}
                            >
                            </CustomListItem>
                        ))}
                    </CustomListContainer>
                </div>
            </div>


        </CustomModal>
    );
};

export default CreationErrorsModal;
